export const QUERY_KEY_PINS = 'Pins'
